import { Skeleton } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import ProjectDetailsSkeleton from './project-details-skeleton';

import Arranger from '~c/components/base/arranger';
import GraphSkeleton from '~c/components/base/graph-card/graph-skeleton';
import Spacer, { spc } from '~c/components/base/spacer';

interface Props {
  className?: string;
}

const DashboardSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      {/* Header: Project Name + (optional) settings gear */}
      <Arranger dir="row" justify="space-between" alignItems="center">
        <Skeleton variant="text" width={240} height={40} />
        <Skeleton variant="circular" width={32} height={32} />
      </Arranger>

      {/* Lifecycle Stepper */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={60}
        sx={{ borderRadius: 1 }}
      />
      <Spacer pb={spc.xs} />

      {/* Risk Details Row — 4 cards (Inherent, Residual, Technology, Policy Compliance) */}
      <div className="details-grid">
        {[0, 1, 2, 3].map((idx) => (
          <ProjectDetailsSkeleton key={idx} />
        ))}
      </div>

      <Spacer pb={spc.s} />

      {/* Pie Graphs */}
      <div className="grid">
        <GraphSkeleton title="TECHNOLOGY RISK STATUS" />
        <GraphSkeleton title="POLICY COMPLIANCE RISK" />
      </div>

      <Spacer pb={spc.s} />

      {/* Risk History Graph */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={340}
        sx={{ borderRadius: 1 }}
      />

      <Spacer pb={spc.s} />

      {/* Governance Table */}
      <Skeleton variant="text" width="20%" height={32} />
      <Spacer pb={spc.xxxs} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={44}
        sx={{ borderRadius: 1 }}
      />
      <Spacer pb={spc.xxxs} />
      {[0, 1, 2, 3].map((idx) => (
        <React.Fragment key={idx}>
          <Skeleton variant="rectangular" width="100%" height={36} />
          <Spacer pb={spc.xxxs} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default muiStyled(DashboardSkeleton)(({ theme }) => {
  return css`
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      gap: 24px;
    }

    .details-grid {
      display: grid;
      gap: 24px;
      ${theme.breakpoints.up('sm')} {
        grid-template-columns: repeat(4, minmax(150px, 1fr));
      }
      ${theme.breakpoints.down('sm')} {
        grid-template-columns: minmax(150px, 1fr);
      }
    }
  `;
});
